import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function loadRelatedProducts() {

    
    const relatedSwiper = new Swiper(".related-products-swiper", {
      watchSlidesProgress: true,
      freeMode: true,
      spaceBetween: 16,
      slidesPerView: 2,
      navigation: {
        nextEl: ".related-product-next",
        prevEl: ".related-product-prev",
      },
      modules: [Navigation],
    });

    
}
